import React, {useContext, useState} from "react";
import {Box, Stack, Typography} from "@mui/material";
import {
  BaseWorldPayload,
  CONTEXT_ACTION_TYPE,
  DataStoreContext,
  STEP_ORDERS,
  STEPS,
  useStep, validateStepOutput
} from "../../contexts/OperatingTestContext";
import {BASE_WORLD_LIST_SORT_ORDERS, BaseWorldListSortOrderValue,} from "../../../../constants/constants";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";
import {FetchMessage} from "../../../../hooks/useFetchAllQuery";
import SortOrder from "../forms/SortOrder";
import {sortBaseWorlds} from "../../../operatingEnvironment/utils/operatingEnvironmentUtil";
import {BaseWorldListItem as BaseBaseWorldListItem} from "../lists/BaseWorldListItem";
import {BaseWorldDocument} from "../../../../types/pj1dbApiWorld";
import {WorldDetailDialog} from "../details/WorldDetailDialog";

export default function BaseWorldSelectionStep() {
  if (!useIsShow()) {
    throw new Error('BaseWorldSelectionStep is not shown');
  }

  const [, setStep] = useStep();
  const {state, dispatch} = useContext(DataStoreContext);
  const baseWorlds = state.baseWorldStep.baseWorlds.map(item => Object.values(item)).flat();

  return (
    <Stack gap={4}>

      <Box display='flex' flexWrap='nowrap' justifyContent='space-between'>
        <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
          検索結果一覧
        </Typography>
        <Stack gap={2}>
          <Pjdb1Button label="機器構成を選択" variant='text'
                       color='inherit'
                       onClick={() => setStep(STEP_ORDERS[STEPS.BASE_WORLD_SELECTION].PREV)}/>
          <Box display='flex' gap={1} alignItems='center'>
            <Box component="span">
              {baseWorlds.length > 0 ? `${baseWorlds.length.toLocaleString()}件` : ""}
            </Box>
            <Box component="span">
              <SortOrder
                value={state.baseWorldStep.searchCond.sortOrder}
                onChange={(event) => {
                  dispatch({
                    type: CONTEXT_ACTION_TYPE.BASE_WORLD,
                    payload: {
                      searchCond: {
                        ...state.baseWorldStep.searchCond,
                        sortOrder: event.target.value as BaseWorldListSortOrderValue
                      }
                    } satisfies BaseWorldPayload
                  });
                }}
                items={Object.values(BASE_WORLD_LIST_SORT_ORDERS)}/>
            </Box>
          </Box>
        </Stack>
      </Box>

      {baseWorlds.length > 0 && (
        <Box display='flex' flexWrap='wrap' gap={2}>
          {sortBaseWorlds(baseWorlds, state.baseWorldStep.searchCond.sortOrder)
            .map(baseWorld => (
              <BaseWorldListItem
                key={baseWorld.attr['world-id']}
                baseWorld={baseWorld}
                onClick={(selectedBaseWorld) => {
                  dispatch({
                    type: CONTEXT_ACTION_TYPE.BASE_WORLD,
                    payload: {selectedBaseWorld} satisfies BaseWorldPayload
                  });
                  setStep(STEP_ORDERS[STEPS.BASE_WORLD_SELECTION].NEXT);
                }}
              />
            ))}
        </Box>
      )}

      <FetchMessage
        data={state.baseWorldStep.baseWorlds}
        status={state.baseWorldStep.searchStatus}
        isEmpty={(value) => value.length === 0
          || value.every(v => Object.values(v).length === 0)
        }
      />
    </Stack>
  );
}

function useIsShow() {
  const {state} = useContext(DataStoreContext);
  const [step] = useStep();

  return step === STEPS.BASE_WORLD_SELECTION &&
    validateStepOutput(state, STEP_ORDERS[STEPS.BASE_WORLD_SELECTION].PREV);
}

function BaseWorldListItem(props: {
  baseWorld: BaseWorldDocument,
  onClick: (baseWorld: BaseWorldDocument) => void,
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <WorldDetailDialog
        open={open}
        worldId={props.baseWorld.attr["world-id"]}
        onClose={() => setOpen(false)}
      />
      <BaseBaseWorldListItem item={props.baseWorld} onClick={() => setOpen(true)}>
        <Pjdb1Button label="カスタムワールドを選択" variant='contained' color='info' onClick={(e) => {
          e.stopPropagation();
          props.onClick(props.baseWorld);
        }}/>
      </BaseBaseWorldListItem>
    </>
  )
}
